import { useEffect, useState } from 'react'

import { useThrottledScroll } from 'services/hooks/'

import { ARTICLE_CONTENT_ID } from '../consts'

import { extractHeadings, flattenHeadings } from './helper'

import css from './TableOfContent.module.css'

function TableOfContent({ modalVisible, collapseTableOfContent }) {
    const [headings, setHeadings] = useState([])
    const [activeSlugs, setActiveSlugs] = useState([])

    useEffect(() => {
        /** Compute headings once the DOM is loaded */
        const articleElement = document.getElementById(ARTICLE_CONTENT_ID)
        /** Adds an `introduction` link if the first element is not a heading */
        const shouldAddIntroduction = articleElement.firstChild
            ? articleElement.firstChild.tagName.substring(0, 1) !== 'H'
            : false
        const newHeadings = extractHeadings(articleElement, shouldAddIntroduction)
        setHeadings(newHeadings)
    }, [])

    useThrottledScroll(() => {
        /* Detect active headers */
        const windowHeight = window.innerHeight
        const flatHeadings = flattenHeadings(headings)
        const lastHeading = flatHeadings.slice().pop()

        function handleScroll() {
            const nextActiveHeading = flatHeadings.find((heading) => {
                const $heading = document.getElementById(heading.slug)
                const headerIsBelowMidScreen = $heading.getBoundingClientRect().y > windowHeight / 2

                return headerIsBelowMidScreen
            })
            if (!nextActiveHeading) {
                return
            }
            const nextActiveHeadingIndex = flatHeadings.indexOf(nextActiveHeading)
            const activeHeading = flatHeadings[nextActiveHeadingIndex - 1] || lastHeading
            const activeSlugsArr = [activeHeading.slug]
            if (activeHeading.parent) activeSlugsArr.push(activeHeading.parent)

            setActiveSlugs(activeSlugsArr)
        }
        handleScroll()

        return handleScroll
    }, [headings])

    return (
        <aside className={`${css.tableOfContent} ${modalVisible ? css.modalVisible : ''}`}>
            <ul>
                {headings.map((h1) => (
                    <LevelOneHeader
                        h1={h1}
                        key={h1.slug}
                        activeSlugs={activeSlugs}
                        collapseTableOfContent={collapseTableOfContent}
                    />
                ))}
            </ul>
        </aside>
    )
}

function LevelOneHeader({ h1, activeSlugs, collapseTableOfContent }) {
    const h1IsActive = activeSlugs.includes(h1.slug)

    return (
        <li className={h1IsActive ? css.liActive : ''}>
            <a
                href={`#${h1.slug}`}
                className={`${css.h1} ${h1IsActive ? css.headerActive : ''}`}
                onClick={() => collapseTableOfContent()}
            >
                {h1.text}
            </a>
            <ul className={css.h2Container}>
                {h1.children.map((h2) => (
                    <LevelTwoHeader
                        key={h2.slug}
                        h2={h2}
                        activeSlugs={activeSlugs}
                        collapseTableOfContent={collapseTableOfContent}
                    />
                ))}
            </ul>
        </li>
    )
}

function LevelTwoHeader({ h2, activeSlugs, collapseTableOfContent }) {
    const h2IsActive = activeSlugs.includes(h2.slug)

    return (
        <li>
            <a
                href={`#${h2.slug}`}
                className={h2IsActive ? css.headerActive : ''}
                onClick={() => collapseTableOfContent()}
            >
                {h2.text}
            </a>
        </li>
    )
}

export default TableOfContent
